import { AbstractControl, ValidationErrors } from '@angular/forms';

export const ValidatorEmail = (control: AbstractControl) => {
    if (control.value === null || control.value === '') {
        return null;
    }

    const email = control.value;

    const EMAIL_REGEXP = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
    
    if (email !== '' && (email.length <= 5 || !EMAIL_REGEXP.test(email))) {
        return { email: true };
    }

    return null;
};
